import axios from "axios";

export const baseURL = process.env.CARDIAC_OUTPUT_API_BASE_URL || 'https://api.adaptivmedical.co.za'; // Your NestJS server URL
export const isValidNumber = /^[0-9]+$/i;
export const isValidNumberWithForwardSlash = /^[0-9/]+$/i;

axios.defaults.baseURL = baseURL; 
